import { render, staticRenderFns } from "./pre-redpacket.vue?vue&type=template&id=41f86fae&"
import script from "./pre-redpacket.vue?vue&type=script&lang=js&"
export * from "./pre-redpacket.vue?vue&type=script&lang=js&"
import style0 from "./pre-redpacket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports